import { formatCurrency } from "../../../Helpers/currency";
import { getQuestionComponents } from "../../../Helpers/productHelper";

export const UpsellComponent = ({ upsell, answers, setAnswers }) => {
  const questionsComponents = [];

  if (upsell.meta_data && upsell.meta_data.length) {
    const productQuestions = upsell.meta_data.find(
      (i) => i.key === "twc_product_questions"
    );

    const productQuestionsTitle = upsell.meta_data.find(
      (i) => i.key === "twc_product_questions_title"
    );

    let productQuestionObject = null;

    if (productQuestions) {
      productQuestionObject = JSON.parse(productQuestions.value);
      questionsComponents.push(
        getQuestionComponents(productQuestionObject, answers, setAnswers)
      );
    }
  }

  return (
    <span>
      {upsell.name}{" "}
      <small className="ms-2">({formatCurrency(upsell.price)})</small>
      {questionsComponents}
    </span>
  );
};
